<template>
  <div v-if="isShowOrganizationModel" class="modal d-block" tabindex="-1" style="background-color: rgba(0, 0, 0, 0.5);">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <!-- Header -->
        <div class="modal-header">
          <h5 class="modal-title">{{ isEditMode ? 'Edit organization' : 'Create organization' }}</h5>
          <button type="button" class="btn-close" aria-label="Close" @click="closeOrganizationModal"></button>
        </div>

        <!-- Form Content -->
        <form @submit.prevent="handleSubmit">
          <div class="modal-body">
            <!-- Row 1: Organization Name, URL, Status -->
            <div class="form-row form-row-3">
              <div class="form-group">
                <label class="form-label required">Organization Name</label>
                <input
                  v-model="formData.organizationName"
                  type="text"
                  placeholder="e.g. Pharma Corp"
                  class="form-input"
                />
                <span v-if="errors.organizationName" class="error-text">
                  {{ errors.organizationName }}
                </span>
              </div>

              <div class="form-group">
                <label class="form-label required">URL / Domain</label>
                <input
                  v-model="formData.url"
                  type="text"
                  placeholder="https://pharma-corp.com"
                  class="form-input"
                />
                <span v-if="errors.url" class="error-text">
                  {{ errors.url }}
                </span>
              </div>

              <div class="form-group">
                <label class="form-label">Status</label>
                <select v-model="formData.isActive" class="form-select">
                  <option :value="true">Active</option>
                  <option :value="false">Inactive</option>
                </select>
              </div>
            </div>

            <!-- Row 2: Root User Name, Root User Email -->
            <div class="form-row">
              <div class="form-group">
                <label class="form-label">Root User Name</label>
                <input
                  v-model="formData.rootUserName"
                  type="text"
                  placeholder="e.g. Dr. Jane Smith"
                  class="form-input"
                />
              </div>

              <div class="form-group">
                <label class="form-label">Root User Email</label>
                <input
                  v-model="formData.rootUserEmail"
                  type="email"
                  placeholder="admin@pharma-corp.com"
                  class="form-input"
                />
              </div>
            </div>

            <!-- Database Connection String -->
            <div class="form-group">
              <label class="form-label">Database Connection String</label>
              <input
                v-model="formData.connectionString"
                type="text"
                placeholder="Server=host;Database=db;User Id=user;Password=pass;"
                class="form-input"
              />
            </div>

            <!-- Row 3: Logo URL, Welcome Text -->
            <div class="form-row">
              <div class="form-group">
                <label class="form-label">Logo URL</label>
                <input
                  v-model="formData.logoUrl"
                  type="text"
                  placeholder="https://.../logo.png"
                  class="form-input"
                />
              </div>

              <div class="form-group">
                <label class="form-label">Welcome Text</label>
                <input
                  v-model="formData.welcomeText"
                  type="text"
                  placeholder="Welcome message shown to users"
                  class="form-input"
                />
              </div>
            </div>
          </div>

          <!-- Action Buttons -->
          <div class="modal-footer">
            <button
              type="button"
              class="button button-secondary"
              @click="closeOrganizationModal"
            >
              Cancel
            </button>
            <button
              type="submit"
              class="button button-primary"
              :disabled="isSubmitting"
            >
              <span v-if="!isSubmitting">✓ {{ isEditMode ? 'Save changes' : 'Create organization' }}</span>
              <span v-else>{{ isEditMode ? 'Saving...' : 'Creating...' }}</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script src="./organizationModel.js"></script>

<style scoped>
* {
  box-sizing: border-box;
}

.form-group {
  margin-bottom: 20px;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.form-row-3 {
  grid-template-columns: repeat(3, 1fr);
}

.form-label {
  display: block;
  font-size: 11px;
  font-weight: 600;
  color: #0c321c;
  text-transform: none;
  letter-spacing: 0.5px;
  margin-bottom: 8px;
}

.form-label.required::after {
  content: ' *';
  color: #ef4444;
}

.form-input,
.form-select {
  width: 100%;
  padding: 6px 8px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 12px;
  color: #1f2937;
  background-color: #ffffff;
  font-family: inherit;
  transition: all 0.2s;
}

.form-input:disabled {
  background-color: #f3f4f6;
  color: #9ca3af;
  cursor: not-allowed;
}

.form-input:focus,
.form-select:focus {
  outline: none;
  border-color: #14b8a6;
  box-shadow: 0 0 0 3px rgba(20, 184, 166, 0.1);
}

.form-input::placeholder {
  color: #9ca3af;
}

.form-select {
  cursor: pointer;
  appearance: none;
  background-repeat: no-repeat;
  background-position: right 10px center;
  padding-right: 30px;
}

.form-helper-text {
  display: block;
  font-size: 12px;
  color: #9ca3af;
  margin-top: 6px;
}

.error-text {
  display: block;
  font-size: 12px;
  color: #ef4444;
  margin-top: 6px;
}

.button {
  padding: 6px 12px;
  border: none;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s;
  font-family: inherit;
}

.button-secondary {
  background-color: #ffffff;
  color: #374151;
  border: 1px solid #d1d5db;
}

.button-secondary:hover {
  background-color: #f9fafb;
  border-color: #9ca3af;
}

.button-primary {
  background-color: #797a7b;;
  color: white;
  font-size: 11px;
}

.button-primary:hover:not(:disabled) {
  background-color: #0d9488;
  box-shadow: 0 4px 12px rgba(20, 184, 166, 0.3);
}

.button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.modal-title{
  font-size: 13px;
  font-weight: 700;
  color: #797a7b;
}
.modal-header{
  padding: 12px 18px;
}
.modal-footer{
  padding: .45rem;
}
.btn-close{
color: #6B7280;
}
/* Responsive design */
@media (max-width: 768px) {
  .form-row-3 {
    grid-template-columns: 1fr 1fr;
  }
}

@media (max-width: 640px) {
  .form-row,
  .form-row-3 {
    grid-template-columns: 1fr;
    gap: 12px;
  }
}

/* Reduced motion support */
@media (prefers-reduced-motion: reduce) {
  * {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}
</style>